import constants from './constants';

const utils = {
    sortBySequence: (a, b) => {
        if (a.sequence < b.sequence) {
            return -1;
        }
        if (a.sequence > b.sequence) {
            return 1;
        }
        if (a.sequence == b.sequence) {
            return 0;
        }
    },
    deepCopy: object => {
        return JSON.parse(JSON.stringify(object));
    },
    validateSimplePrescriptionObject: prescriptionObject => {
        return (
            prescriptionObject &&
            prescriptionObject.SPH !== undefined &&
            prescriptionObject.SPH !== null &&
            prescriptionObject.SPH.OD !== undefined &&
            prescriptionObject.SPH.OD !== null &&
            !isNaN(prescriptionObject.SPH.OD) &&
            prescriptionObject.SPH.OS !== undefined &&
            prescriptionObject.SPH.OS !== null &&
            !isNaN(prescriptionObject.SPH.OS) &&
            prescriptionObject.ADD !== undefined &&
            prescriptionObject.ADD !== null &&
            typeof prescriptionObject.ADD == 'boolean'
        );
    },
    validateFullPrescriptionObject: prescriptionObject => {
        if (prescriptionObject) {
            if (
                prescriptionObject.SPH !== undefined &&
                prescriptionObject.SPH !== null &&
                prescriptionObject.SPH.OD !== undefined &&
                prescriptionObject.SPH.OD !== null &&
                !isNaN(prescriptionObject.SPH.OD) &&
                prescriptionObject.SPH.OS !== undefined &&
                prescriptionObject.SPH.OS !== null &&
                !isNaN(prescriptionObject.SPH.OS) &&
                prescriptionObject.CYL !== undefined &&
                prescriptionObject.CYL !== null &&
                prescriptionObject.CYL.OD !== undefined &&
                prescriptionObject.CYL.OD !== null &&
                !isNaN(prescriptionObject.CYL.OD) &&
                prescriptionObject.CYL.OS !== undefined &&
                prescriptionObject.CYL.OS !== null &&
                !isNaN(prescriptionObject.CYL.OS)
            ) {
                if (
                    (prescriptionObject.AX !== undefined &&
                        prescriptionObject.AX !== null &&
                        ((prescriptionObject.AX.OD !== undefined &&
                            prescriptionObject.AX.OD !== null) ||
                            (prescriptionObject.AX.OS !== undefined &&
                                prescriptionObject.AX.OS !== null))) ||
                    (prescriptionObject.ADD !== undefined &&
                        prescriptionObject.ADD !== null &&
                        ((prescriptionObject.ADD.OD !== undefined &&
                            prescriptionObject.ADD.OD !== null) ||
                            (prescriptionObject.ADD.OS !== undefined &&
                                prescriptionObject.ADD.OS !== null))) ||
                    (prescriptionObject.PD !== undefined &&
                        prescriptionObject.PD !== null &&
                        prescriptionObject.PD.OD !== undefined &&
                        prescriptionObject.PD.OD !== null)
                ) {
                    if (
                        prescriptionObject.AX.OD !== undefined &&
                        prescriptionObject.AX.OD !== null &&
                        !isNaN(prescriptionObject.AX.OD) &&
                        prescriptionObject.AX.OS !== undefined &&
                        prescriptionObject.AX.OS !== null &&
                        !isNaN(prescriptionObject.AX.OS)
                    ) {
                        if (
                            prescriptionObject.ADD.OD !== undefined &&
                            prescriptionObject.ADD.OD !== null &&
                            !isNaN(prescriptionObject.ADD.OD) &&
                            prescriptionObject.ADD.OS !== undefined &&
                            prescriptionObject.ADD.OS !== null &&
                            !isNaN(prescriptionObject.ADD.OS)
                        ) {
                            if (
                                prescriptionObject.PD.OD !== undefined &&
                                prescriptionObject.PD.OD !== null &&
                                !isNaN(prescriptionObject.PD.OD)
                            ) {
                                return true;
                            } else {
                                return false;
                            }
                        } else {
                            return false;
                        }
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            } else {
                return false;
            }
        } else {
            return false;
        }
    },
    getSimplePrescriptionObject: prescriptionFormData => {
        let prescriptionObject = {
            SPH: {
                OD: parseFloat(prescriptionFormData.sph_od),
                OS: parseFloat(prescriptionFormData.sph_os),
            },
            ADD: prescriptionFormData.addCheck,
        };

        if (prescriptionFormData.cyl_od && prescriptionFormData.cyl_os) {
            prescriptionObject.CYL = {
                OD: parseFloat(prescriptionFormData.cyl_od),
                OS: parseFloat(prescriptionFormData.cyl_os),
            };
        }
        return prescriptionObject;
    },
    getFullPrescriptionObject: prescriptionFormData => {
        let prescriptionObject = {
            SPH: {
                OD: parseFloat(prescriptionFormData.sph_od),
                OS: parseFloat(prescriptionFormData.sph_os),
            },
            AX: null,
            ADD: null,
            PD: null,
        };

        if (prescriptionFormData.cyl_od && prescriptionFormData.cyl_os) {
            prescriptionObject.CYL = {
                OD: parseFloat(prescriptionFormData.cyl_od),
                OS: parseFloat(prescriptionFormData.cyl_os),
            };
        }
        if (prescriptionFormData.axis_od !== undefined) {
            prescriptionObject.AX = {
                OD: parseFloat(prescriptionFormData.axis_od),
            };
        }
        if (prescriptionFormData.axis_os !== undefined) {
            prescriptionObject.AX.OS = parseFloat(prescriptionFormData.axis_os);
        }
        if (
            prescriptionFormData.add_od !== undefined &&
            prescriptionFormData.add_os !== undefined
        ) {
            prescriptionObject.ADD = {
                OD: parseFloat(prescriptionFormData.add_od),
                OS: parseFloat(prescriptionFormData.add_os),
            };
        }
        if (prescriptionFormData.pd_od !== undefined && prescriptionFormData.pd_od !== '') {
            prescriptionObject.PD = {
                OD: parseFloat(prescriptionFormData.pd_od),
            };
        }
        if (
            prescriptionFormData.pdCheck &&
            prescriptionFormData.pd_os !== undefined &&
            prescriptionFormData.pd_os !== ''
        ) {
            prescriptionObject.PD.OS = parseFloat(prescriptionFormData.pd_os);
        }
        return prescriptionObject;
    },
    hasValidPrescription: (currentPackage, prescriptionObject) => {
        let hasValidPrescriptionValue = false;
        if (prescriptionObject) {
            if (currentPackage.lensPackage.rxValues !== null) {
                if (
                    parseFloat(prescriptionObject.SPH.OD) >=
                        parseFloat(currentPackage.lensPackage.rxValues.sph.min) &&
                    parseFloat(prescriptionObject.SPH.OD) <=
                        parseFloat(currentPackage.lensPackage.rxValues.sph.max) &&
                    parseFloat(prescriptionObject.SPH.OS) >=
                        parseFloat(currentPackage.lensPackage.rxValues.sph.min) &&
                    parseFloat(prescriptionObject.SPH.OS) <=
                        parseFloat(currentPackage.lensPackage.rxValues.sph.max) &&
                    (!prescriptionObject.CYL ||
                        (prescriptionObject.CYL &&
                            parseFloat(prescriptionObject.CYL.OD) >=
                                parseFloat(currentPackage.lensPackage.rxValues.cyl.min) &&
                            parseFloat(prescriptionObject.CYL.OD) <=
                                parseFloat(currentPackage.lensPackage.rxValues.cyl.max) &&
                            parseFloat(prescriptionObject.CYL.OS) >=
                                parseFloat(currentPackage.lensPackage.rxValues.cyl.min) &&
                            parseFloat(prescriptionObject.CYL.OS) <=
                                parseFloat(currentPackage.lensPackage.rxValues.cyl.max)))
                ) {
                    if (
                        prescriptionObject.AX !== undefined ||
                        prescriptionObject.PD !== undefined
                    ) {
                        // Full prescription
                        if (
                            prescriptionObject.ADD !== undefined &&
                            prescriptionObject.ADD !== null &&
                            prescriptionObject.ADD.OD !== undefined &&
                            prescriptionObject.ADD.OD !== null &&
                            prescriptionObject.ADD.OS !== undefined &&
                            prescriptionObject.ADD.OS !== null &&
                            currentPackage.lensPackage.rxValues.add !== undefined &&
                            currentPackage.lensPackage.rxValues.add !== null &&
                            currentPackage.lensPackage.rxValues.add.min !== undefined &&
                            currentPackage.lensPackage.rxValues.add.min !== null &&
                            currentPackage.lensPackage.rxValues.add.max !== undefined &&
                            currentPackage.lensPackage.rxValues.add.max !== null
                        ) {
                            if (
                                parseFloat(prescriptionObject.ADD.OD) >=
                                    parseFloat(currentPackage.lensPackage.rxValues.add.min) &&
                                parseFloat(prescriptionObject.ADD.OD) <=
                                    parseFloat(currentPackage.lensPackage.rxValues.add.max) &&
                                parseFloat(prescriptionObject.ADD.OS) >=
                                    parseFloat(currentPackage.lensPackage.rxValues.add.min) &&
                                parseFloat(prescriptionObject.ADD.OS) <=
                                    parseFloat(currentPackage.lensPackage.rxValues.add.max)
                            ) {
                                hasValidPrescriptionValue = true;
                            }
                        } else if (!prescriptionObject.ADD) {
                            hasValidPrescriptionValue = true;
                        }
                    } else {
                        // Simple prescription
                        if (
                            prescriptionObject.ADD == true &&
                            currentPackage.lensPackage.rxValues.add !== null
                        ) {
                            // Add checkbox checked in simple prescription, progressive lenses only
                            hasValidPrescriptionValue = true;
                        } else if (
                            !prescriptionObject.ADD &&
                            currentPackage.lensPackage.rxValues.add == null
                        ) {
                            // Add checkbox NOT checked in simple prescription, single vision lenses only
                            hasValidPrescriptionValue = true;
                        }
                    }
                }
            }
        } else {
            hasValidPrescriptionValue = true;
        }

        return hasValidPrescriptionValue;
    },
    getCompatibleLensesType: (lensPackages, prescriptionObject) => {
        let compatibleLensesType = null;
        for (let i in lensPackages) {
            if (utils.hasValidPrescription(lensPackages[i], prescriptionObject)) {
                compatibleLensesType = lensPackages[i].lensPackage.type;
                break;
            }
        }
        return compatibleLensesType;
    },
    getValuesArray: (start, end, incrementValue, noValueSymbol) => {
        let valuesArray = [];
        valuesArray.push({ name: noValueSymbol, value: '' });
        for (let i = start; i <= end; ) {
            valuesArray.push({ name: i, value: parseFloat(i) });
            i = parseFloat(i) + parseFloat(incrementValue);
        }
        return valuesArray;
    },
    isFramePrescriptionCompatible: (rxValues, prescriptionObject) => {
        if (rxValues && prescriptionObject && prescriptionObject.SPH) {
            let A = parseFloat(prescriptionObject.SPH.OD);
            let B =
                A +
                (prescriptionObject.CYL &&
                prescriptionObject.CYL.OD !== undefined &&
                prescriptionObject.CYL.OD !== null
                    ? parseFloat(prescriptionObject.CYL.OD)
                    : 0.0);
            let C = parseFloat(prescriptionObject.SPH.OS);
            let D =
                C +
                (prescriptionObject.CYL &&
                prescriptionObject.CYL.OS !== undefined &&
                prescriptionObject.CYL.OS !== null
                    ? parseFloat(prescriptionObject.CYL.OS)
                    : 0.0);

            let values = [A, B, C, D];
            let maxIndex = 0;

            values.forEach((value, index) => {
                if (Math.abs(value) > Math.abs(values[maxIndex])) {
                    maxIndex = index;
                }
            });

            let combinedTotalPower = values[maxIndex];

            console.log('COMBINED POWER', combinedTotalPower);

            if (
                parseFloat(rxValues.powerCombinedMin) <= combinedTotalPower &&
                parseFloat(rxValues.powerCombinedMax) >= combinedTotalPower
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    },
    checkGVP: data => {
        let isGVP = false;

        if (data.packages && data.packages.length > 0 && data.packages[0].frame) {
            const isFirstGVP = data.packages[0].frame.promoType === constants.promoTypes.GVP;

            isGVP = data.packages.reduce((isPrevGVP, currentPackage) => {
                return isPrevGVP || currentPackage.frame.promoType === constants.promoTypes.GVP;
            }, isFirstGVP);
        }

        return isGVP;
    },
};

export default utils;
